import React,{useState, useEffect} from 'react';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import axiosInstance from '../../server/axios.js';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
    >
    {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}
  function a11yProps(index) {
    return {id: `simple-tab-${index}`,'aria-controls': `simple-tabpanel-${index}`};
  }
const Stock = () => {
  //tab value variable
  const [value, setValue] = useState(0);
  const [detector, setDetector] = useState(0);
  const [stockList, setStockList] = useState([]);
  const [menuList, setMenuList] = useState([]);

  //height
  const [height, setHeight] = useState(window.innerHeight - 145);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  useEffect(() => {getMaterialList()},[detector])

  const getMaterialList = async () => {
    const MaterialList = await axiosInstance.get('material/stock');
    const menulist = MaterialList.data.menu.map((value)=> String(value));
    setMenuList([...menulist])

    const stock = [];
    for(let i = 0; i < MaterialList.data.list.length; i++){
      let obj = MaterialList.data.list[i];
      obj.num = i + 1;
      stock.push(obj);
    }
    setStockList([...stock])
  }
  const stockInfo = async (materialCode) => {
    console.log(materialCode);
    //const materialinfo = await axiosInstance.get('material/info');
  }
  const sortTable = (index) => {
    const checkMenuArr = ['num','name','three','two','one','this','result','cal','turnover','code'];
    const menuCopyList = [...menuList];
    let sortDirection = menuCopyList[index].includes('🔻') ? -1 : 1;

    //sortMenuList initiallized
    for(let i = 0; i < menuCopyList.length; i++){
      menuCopyList[i] =  menuCopyList[i].replace(/🔻/gi, '').replace(/🔺/gi, '');
    }
    menuCopyList[index] += sortDirection === 1 ? '🔻' : '🔺'
    setMenuList([...menuCopyList]);


    //sortDataList
    const sortDataList = (stockList,checkMenuArr,sortDirection) => {
      return stockList.sort((a,b)=>{
        if(a[checkMenuArr[index]] < b[checkMenuArr[index]])return 1*sortDirection; 
        if(a[checkMenuArr[index]] > b[checkMenuArr[index]])return -1*sortDirection;
        return 0;
      });
    }
    setStockList([...sortDataList(stockList,checkMenuArr,sortDirection)]);
  }

  const changeNumber = (_number) => {
    return _number === '0' || _number === 0 ? '' : Number(_number).toLocaleString() ;
  }

  return (
    <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="재고(전체)" {...a11yProps(0)} />
            <Tab label="재고(그룹)" {...a11yProps(1)} />
            <Tab label="재고(지정)" {...a11yProps(2)} />
            <Tab label="설정" {...a11yProps(3)} />
        </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
        {/* stock total part
            cal: 0
            code: "090101827111"
            name: "(구)Nikkasol TS-620"
            one: 0
            result: 0
            this: 0
            three: 0
            turnover: null
            two: 0
        */}
        <table className="company_main">
          <thead key={'head'}>
          <tr key={'menu'}>
          {menuList.map((menu,i)=>
            <th key={i+menu} onClick={()=>sortTable(i)}>
              <div style={{paddingLeft:'20px',paddingRight:'20px'}}>
              {menu} <br></br>{i === 2 || i === 3 || i === 4 || i === 5 ? `출고량` : ''}
              </div>
            </th>
          )}
          </tr>
          </thead>
          <tbody>
          {stockList.map((data,index)=>
          <tr key={data.code} onClick={()=>stockInfo(data.code)}>
            <td>{data.num}</td>
            <td style={{paddingLeft:'20px',paddingRight:'20px'}} align='left'>{data.name}</td>
            <td style={{paddingLeft:'20px',paddingRight:'20px'}} align='right'>{changeNumber(data.three)}</td>
            <td style={{paddingLeft:'20px',paddingRight:'20px'}} align='right'>{changeNumber(data.two)}</td>
            <td style={{paddingLeft:'20px',paddingRight:'20px'}} align='right'>{changeNumber(data.one)}</td>
            <td style={{paddingLeft:'20px',paddingRight:'20px'}} align='right'>{changeNumber(data.this)}</td>
            <td style={{paddingLeft:'20px',paddingRight:'20px'}} align='right'>{changeNumber(data.result)}</td>
            <td style={{paddingLeft:'20px',paddingRight:'20px'}} align='right'>{changeNumber(data.cal)}</td>
            <td style={{paddingLeft:'20px',paddingRight:'20px'}} align='right'>{data.turnover}</td>
          </tr>
          )}
          </tbody>
        </table>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
        재고(그룹)
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
        재고(지정)
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
        설정
        </CustomTabPanel>
    </Box>
  )
}
export default Stock;


/*
    return (
      <div style={{display:'flex',justifyContent:'start',alignItems:'flex-start'}}>
        <div>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-around',backgroundColor:'powderblue',width:'450px'}}>
            <div>No</div>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-evenly'}}>
              품명  <TextField id="outlined-basic" label="제품 검색" variant="outlined" size='small' onChange={(e)=>searchMaterial(e)} />
            </div>
          </div>            




        <FixedSizeList height={height} itemCount={stockList.length} itemSize={30} width={"100%"}>
        {({ index, style }) => (
          <div>
            <Button
              onClick={() => getData(stockList[index].code, viewList[index].name)}
              size='small'
              variant="outlined"
            >
              {index + 1}
            </Button>
            <Button 
            onClick={()=>getData(stockList[index].code,stockList[index].name)} 
            size='small' 
            variant="outlined" 
            style={{width:'330px',justifyContent:'start',whiteSpace:'nowrap',overflow:'hidden',color:'black'}}
          >
            {stockList[index].name}
          </Button>
          </div>
        )}
        </FixedSizeList>          






        <div>
            <FixedSizeList height={height} itemCount={stockList.length} itemSize={30} width="450px">
            {({ index, style }) => (
              <div style={style}>
                <Button
                  onClick={() => getData(stockList[index].materialcode, viewList[index].materialname)}
                  size='small'
                  variant="outlined"
                >
                  {index + 1}
                </Button>
                <Button 
                onClick={()=>getData(viewList[index].materialcode,viewList[index].materialname)} 
                size='small' 
                variant="outlined" 
                style={{width:'330px',justifyContent:'start',whiteSpace:'nowrap',overflow:'hidden',color:'black'}}
              >
                {viewList[index].materialname}
              </Button>
              </div>
            )}
            </FixedSizeList>          
        </div>






        </div>
      <div style={{display:'inline-block',marginLeft:'10px'}}>
                <LotSelectMaterial data={contents} update={getContents}></LotSelectMaterial>
      </div>
      </div>
    )
    */
